<template>
  <div>
    <transition-group
      v-for="position in positions"
      :key="position"
      :name="`list-${getFirstPosition(position)}`"
      tag="div"
      :class="`notification-container notification-container--${getFirstPosition(
        position
      )} notification-container--${getSecondPosition(position)}`"
    >
      <app-notification
        v-for="(notification, index) in notifications[position]"
        :key="notification"
        v-bind="notification"
        @close="removeNotification(position, index)"
      />
    </transition-group>
  </div>
</template>

<script setup>
import AppNotification from 'components/AppNotification.vue'
import { ref } from 'vue'

const positions = ['top-right', 'top-left', 'top-center', 'bottom-right', 'bottom-left', 'bottom-center']

const getFirstPosition = (position) => {
  return position.split('-')[0]
}
const getSecondPosition = (position) => {
  return position.split('-')[1]
}

const notifications = ref({
  'top-right': [],
  'top-left': [],
  'top-center': [],
  'bottom-right': [],
  'bottom-left': [],
  'bottom-center': [],
})

const addNotification = (notification) => {
  const position = notification.position || 'bottom-center'
  notifications.value[position].unshift({ ...notification, id: Date.now() })
}

const removeNotification = (position, index) => {
  notifications.value[position].splice(index, 1)
}

defineExpose({ addNotification })
</script>

<style lang="scss">
.notification-container {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-wrap: nowrap;
  pointer-events: none;
}
.notification-container--top {
  top: 0;
  flex-direction: column;
  margin-top: 38px;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    margin-top: 102px;
  }
}
.notification-container--right {
  align-items: flex-end;
}
.notification-container--left {
  align-items: flex-start;
}
.notification-container--center {
  align-items: center;
}

.notification-container--bottom {
  bottom: 0;
  flex-direction: column-reverse;
  margin-bottom: 10px;
}
.notification-container--right {
  align-items: flex-end;
}
.notification-container--left {
  align-items: flex-start;
}
.notification-container--center {
  align-items: center;
}

.list-top-enter-active,
.list-top-leave-active {
  transition: transform 1s, opacity 0.5s;
}
.list-top-leave-active {
  position: absolute;
  z-index: 9499;
}
.list-top-enter-from,
.list-top-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.list-bottom-enter-active,
.list-bottom-leave-active {
  transition: transform 1s, opacity 0.5s;
}
.list-bottom-leave-active {
  position: absolute;
  z-index: 9499;
}
.list-bottom-enter-from,
.list-bottom-leave-to {
  opacity: 0;
  transform: translateY(50px);
}
</style>
